import VisiteMedicheQuickFilter from "./VisiteMedicheQuickFilter";
import VisiteMedicheToolbar from "./VisiteMedicheToolbar";
import React, { useEffect, useState, useMemo, useRef } from "react";
import unsplash from "../api/unsplash";
import { useLocation, useNavigate } from "react-router-dom";

import {
  LinearProgress,
  Checkbox,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  TextField,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  Popover,
  DialogActions,
  Box,
  Typography,
  Step,
  StepLabel,
  Stepper,
  CircularProgress,
  OutlinedInput,
  Card,
  CardContent,
  ButtonGroup,
  Tooltip,
  Zoom,
} from "@mui/material";
import {
  DataGridPro,
  GridToolbar,
  itIT,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from "../utils/PersistedDataGridPro";
import { CustomFooterPersonalized } from "../utils/CustomFooterPersonalized";
import {
  buildAccertamentiVisitaRows,
  getAccertamentiVisitaSelectionChanges,
  getAccertamentiVisitaRowId,
  getAccertamentiVisitaSelectedRows,
  getAccertamentiVisitaSelectionRowIds,
  renderAccertamentoVisitaCell,
} from "../utils/accertamentiVisitaRows";
import {
  Add,
  CheckBox,
  Circle,
  Delete,
  Edit,
  Flight,
} from "@mui/icons-material";
import GlobalSnackbar from "./Snackbar";
import {
  Error,
  HourglassBottom,
  HourglassDisabled,
  Print,
  ErrorOutline,
  InsertDriveFile,
  UploadFile,
  Check,
  Close,
  Email,
  ArrowDropUp,
  Person,
} from "@mui/icons-material";

import {
  LocalizationProvider,
  DatePicker,
  PickersDay,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import momentTimezone from "moment-timezone";
import moment from "moment-timezone";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Dropzone from "react-dropzone";
import DropzoneComponent from "react-dropzone-component";
import { useDropzone } from "react-dropzone";
import Upload from "@mui/icons-material/Upload";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GroupsIcon from "@mui/icons-material/Groups";
import PrintIcon from "@mui/icons-material/Print";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import Grow from "@mui/material/Grow";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const DateRangeFilters = React.memo(function DateRangeFilters({
  dal,
  al,
  onApplyRange,
}) {
  const [draftDal, setDraftDal] = useState(dal);
  const [draftAl, setDraftAl] = useState(al);

  useEffect(() => {
    setDraftDal(dal);
  }, [dal]);

  useEffect(() => {
    setDraftAl(al);
  }, [al]);

  useEffect(() => {
    if (!draftDal || !draftAl) {
      return;
    }

    const timeoutId = setTimeout(() => {
      if (draftDal !== dal || draftAl !== al) {
        onApplyRange(draftDal, draftAl);
      }
    }, 800);

    return () => clearTimeout(timeoutId);
  }, [draftDal, draftAl, dal, al, onApplyRange]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            ampmInClock={false}
            slotProps={{
              textField: { size: "small", fullWidth: true },
            }}
            label="Dal"
            value={draftDal ? moment(draftDal) : null}
            onChange={(newValue) => {
              setDraftDal(newValue ? newValue.format("YYYY-MM-DD") : null);
            }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={4}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            ampmInClock={false}
            slotProps={{
              textField: { size: "small", fullWidth: true },
            }}
            label="Al"
            value={draftAl ? moment(draftAl) : null}
            onChange={(newValue) => {
              setDraftAl(newValue ? newValue.format("YYYY-MM-DD") : null);
            }}
          />
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
});

const VisiteMediche = () => {
  const navigate = useNavigate();
  const [visite, setVisite] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visiteBackup, setVisiteBackup] = useState([]);
  const [mansioni, setMansioni] = useState([]);
  const [medici, setMedici] = useState([]);
  const [visitaSel, setVisitaSel] = useState([]);
  const [esiti, setEsiti] = useState();
  const [tipologiaVisita, setTipologiaVisita] = useState();
  const [dal, setDal] = useState(
    moment(new Date()).subtract(6, "months").format("YYYY-MM-DD"),
  );
  const [al, setAl] = useState(moment(new Date()).format("YYYY-MM-DD"));

  const [visiteSelezionate, setVisiteSelezionate] = useState([]);
  const [visiteSelezionateAPI, setVisiteSelezionateAPI] = useState([]); //quelle da mandare per le API
  const [filtroClessidera, setFiltroClessidera] = useState({
    verde: true,
    arancione: true,
    rosso: true,
    alert: true,
  });
  const [filtroEtichette, setFiltroEtichette] = useState({
    Medico: "",
    Lavoratore: "",
    Mansione: "",
    Accertamenti: "",
    Cliente: "",
    Blocco: "",
  });

  const [openButtonReport, setOpenButtonReport] = useState(false);
  const [reportLavoratori, setReportLavoratori] = useState([]);
  const [reportReferenti, setReportReferenti] = useState([]);

  const [missingEmailLav, setMissingEmailLav] = useState([]);
  const [missingEmailRef, setMissingEmailRef] = useState([]);

  const [optionReport, setOprionReport] = useState("");

  const anchorRefReport = useRef(null);
  const [selectedIndexReport, setSelectedIndexReport] = useState(1);
  const [expanded, setExpanded] = useState(false);

  const [loadingEmail, setLoadingEmail] = useState(false);

  const [changeDialog, setChangeDialog] = useState(false);
  const [open, setOpen] = useState(false);

  const [openSnack, setOpenSnack] = useState(false);
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const columns = [
    {
      filterable: false,
      headerName: "Azioni",
      field: "Actions",
      width: 70,
      headerAlign: "center",
      align: "center",
      sort: "asc",

      renderCell: (params) => {
        return (
          <div>
            <IconButton
              aria-label="edit"
              onClick={(event) => {
                event.currentTarget.blur();
                setVisitaSel(params.row);
                setTimeout(() => {
                  document.getElementById("myDialog")?.click();
                }, 0);
              }}
            >
              <Edit
                style={{ height: "2rem", width: "2rem", color: "#2265B1" }}
              />
            </IconButton>
          </div>
        );
      },
    },
    {
      filterable: false,
      headerName: "*",
      field: "clessidera",
      width: 70,
      headerAlign: "center",
      align: "center",
      sort: "asc",

      renderCell: (params) => {
        return (
          <div>
            {
              /*1*/ moment(params.row.Data).format("YYYY-MM-DD") <
                moment(new Date()).format("YYYY-MM-DD") &&
              params.row.Esito <= 1 ? (
                <HourglassBottom sx={{ color: "#FF2768" }} />
              ) : params.row.Esito > 1 ? (
                <HourglassBottom sx={{ color: "#40C18F" }} />
              ) : (
                <HourglassBottom sx={{ color: "#FFC897" }} />
              )
            }
          </div>
        );
      },
    },
    {
      field: "D",
      headerName: "D",
      width: 10,

      renderCell: (
        params, //mi aiuta a mettere il valore
      ) => (
        <div>
          {params.row.RagioneSocialeDa ? (
            <Tooltip title={"Distaccato da " + params.row.RagioneSocialeDa}>
              <Flight
                className="hover:cursor-pointer"
                sx={{ rotate: "135deg", color: "#9059C3" }}
              />
            </Tooltip>
          ) : (
            ""
          )}
        </div>
      ),
      ///<Flight  sx={{rotate:"135deg",, color: "#9059C3"}}/>
    },
    {
      filterable: false,
      headerName: "**",
      field: "LimitazioniPassate",
      width: 50,
      headerAlign: "center",
      align: "center",
      sort: "asc",

      renderCell: (params) => {
        if (params.row.Esito === 3 || params.row.Esito === 4) {
          return (
            <div>
              <Error sx={{ color: "#FFC897" }} />
            </div>
          );
        } else {
          return "";
        }
      },
    },
    {
      filterable: false,
      headerName: "Idoneità",
      field: "Idoneita",
      width: 70,
      headerAlign: "center",
      align: "center",
      sort: "asc",

      renderCell: (params) => {
        if (params.row.Idoneita === 1) {
          return (
            <div>
              <input type="checkbox" checked></input>
            </div>
          );
        } else {
          return (
            <div>
              <input type="checkbox" disabled></input>
            </div>
          );
        }
      },

      /*renderCell: (params) =>{

          if(params.row.Idoneita === 1){
              return <div><Error sx={{color:"#FFC897"}} /></div>
          }else{
              return ""
          }

      }*/
    },
    {
      field: "Cliente",
      headerName: "Cliente",
      width: 200,

      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (params) => {
        return (
          <Tooltip title={params.row.Cliente}>
            <div className="firstLetterUppercase">{params.row.Cliente}</div>
          </Tooltip>
        );
      },
    },
    {
      field: "Blocco",
      headerName: "Blocco",
      width: 200,

      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "ClienteAttuale",
      headerName: "Cliente Attuale",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "Categoria",
      headerName: "Categoria",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "LavoratoreCognome",
      headerName: "Cognome",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "LavoratoreNome",
      headerName: "Nome",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "Medico",
      headerName: "Medico",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "Mansione",
      headerName: "Mansione",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "Accertamenti",
      headerName: "Accertamenti",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "EsitoDesc",
      headerName: "Esito",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
      valueGetter: (params) => {
        const esito = params?.row?.Esito;
        // In tabella: se non c'e' esito lo nascondiamo.
        if (esito === null || esito === undefined || esito === 0) return "";
        return params?.row?.EsitoDesc || "";
      },
    },
    {
      field: "TipoVDesc",
      headerName: "Tipo",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "Data",
      headerName: "Data",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (params) => {
        return (
          <div>
            {params.row.Data
              ? moment(params.row.Data).format("DD/MM/YYYY")
              : ""}
          </div>
        );
      },
    },
    {
      field: "Scadenza",
      headerName: "Scadenza",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (params) => {
        return (
          <div>
            {params.row.Scadenza
              ? moment(params.row.Scadenza).format("DD/MM/YYYY")
              : ""}
          </div>
        );
      },
    },
    {
      field: "CF",
      headerName: "CF",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "UnitaProduttivaAllegato3B",
      headerName: "Unità Produttiva",
      width: 200,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "DataDiNascita",
      headerName: "Data Di Nascita",
      width: 100,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (params) => {
        return (
          <div>
            {params.row.DataDiNascita
              ? moment(params.row.DataDiNascita).format("DD/MM/YYYY")
              : ""}
          </div>
        );
      },
    },
    {
      field: "LuogoDiNascita",
      headerName: "Luogo Di Nascita",
      width: 100,
      //flex:1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
  ];

  const optionsReport = [
    {
      icon: <GroupsIcon />,
      text: "DIPENDENTI",
      ind: 4,
    },
    {
      icon: <Person />,
      text: "REFERENTI",
      ind: 5,
    },
  ];

  useEffect(() => {
    // è un loop qui carico i dati
    const fetchData = async () => {
      try {
        let response = await unsplash.get("visiteMediche", {
          params: {
            dal: moment(new Date()).subtract(6, "months").format("YYYY-MM-DD"),
            al: moment(new Date()).format("YYYY-MM-DD"),
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });
        setVisite(response.data.data);
        setLoading(false);
        setVisiteBackup(response.data.data);
        let responseEsiti = await unsplash.get("esiti", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });
        setEsiti(responseEsiti.data.data);

        let responseTipologiaVisita = await unsplash.get("tipologiaVisita", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });
        setTipologiaVisita(responseTipologiaVisita.data.data);

        let responseMansioni = await unsplash.get("mansioni", {
          params: { id: -1 },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });

        setMansioni(responseMansioni.data.data);

        let responseMedici = await unsplash.get("medici", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });

        setMedici(responseMedici.data.data?.filter((el) => el?.Attivo === 1));
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchData();
  }, []);

  const handleApplyDateRange = React.useCallback((newDal, newAl) => {
    if (!newDal || !newAl) {
      return;
    }

    setDal(newDal);
    setAl(newAl);
    loadVisite(newDal, newAl);
  }, []);

  const loadVisite = async (dal, al) => {
    if (dal && al) {
      let response = await unsplash.get("visiteMediche", {
        params: { dal: dal, al: al },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      });
      let visiteTemp = response.data.data;

      if (filtroEtichette.Medico !== "") {
        visiteTemp = visiteTemp.filter((v) =>
          v.Medico.toLowerCase().includes(filtroEtichette.Medico.toLowerCase()),
        );
      }

      if (filtroEtichette.Lavoratore !== "") {
        visiteTemp = visiteTemp.filter((v) =>
          v.LavoratoreNome.toLowerCase().includes(
            filtroEtichette.Lavoratore.toLowerCase() ||
              v.LavoratoreCognome.toLowerCase().includes(
                filtroEtichette.Lavoratore.toLowerCase(),
              ),
          ),
        );
      }
      if (filtroEtichette.Mansione !== "") {
        visiteTemp = visiteTemp.filter((v) =>
          v.Mansione.toLowerCase().includes(
            filtroEtichette.Mansione.toLowerCase(),
          ),
        );
      }
      if (filtroEtichette.Accertamenti !== "") {
        visiteTemp = visiteTemp.filter((v) =>
          v.Accertamenti.toLowerCase().includes(
            filtroEtichette.Accertamenti.toLowerCase(),
          ),
        );
      }
      if (filtroEtichette.Cliente !== "") {
        visiteTemp = visiteTemp.filter((v) =>
          v.Cliente.toLowerCase().includes(
            filtroEtichette.Cliente.toLowerCase(),
          ),
        );
      }
      if (filtroEtichette.Blocco !== "") {
        visiteTemp = visiteTemp.filter((v) =>
          v.Blocco.toLowerCase().includes(filtroEtichette.Blocco.toLowerCase()),
        );
      }

      setVisite(visiteTemp);
      setVisiteBackup(response.data.data);
    }
  };

  const updateData = (visitaAggiornata, accertamenti) => {
    let vis = { ...visitaAggiornata };
    vis.Data = moment(vis.Data).format("YYYY-MM-DD HH:mm:ss");
    let accText = accertamenti.map((acc) => acc.Descrizione);
    vis.Accertamenti = accText.join();

    let visiteTemp = [...visite];
    const index = visiteTemp.findIndex((v) => {
      return v.ID === vis.ID;
    });

    if (index > -1) {
      visiteTemp.splice(index, 1); // Rimuovo solo un elemento
      visiteTemp.splice(index, 0, vis); //serve per aggiungere in posizione index, l'elemento dopo lo 0. Lo 0 serve per non eliminare nulla
    }
    setVisite(visiteTemp);
  };

  const printIdoneita = async () => {
    let response = await unsplash.get("visiteMediche", {
      params: { visite: visiteSelezionateAPI },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });

    let visite = [...visiteSelezionate];
    const dettagliPerVisita = new Map(
      response.data.res.map((dettaglio) => [dettaglio.ID, dettaglio]),
    );
    visite = visite.map((visita) => {
      const dettaglio = dettagliPerVisita.get(visita.ID);
      if (!dettaglio) return visita;

      return {
        ...visita,
        Rischi: dettaglio.Rischi,
        DescRischi: dettaglio.DescRischi,
        ScadenzaAnni: dettaglio.ScadenzaAnni,
        AccertamentiStampa: dettaglio.AccertamentiStampa,
      };
    });
    navigate("/Idoneita", { state: { visite: visite } });
  };

  const filterClessidera = (e, colore) => {
    let f = { ...filtroClessidera };
    f[colore] = e.target.checked;
    setFiltroClessidera(f);
    let visiteTemp = visiteBackup;
    if (!f.rosso) {
      visiteTemp = visiteTemp.filter(
        (v) =>
          v.Esito >= 1 ||
          moment(v.Data).format("YYYY-MM-DD") >
            moment(new Date()).format("YYYY-MM-DD"),
      );
    }

    if (!f.verde) {
      visiteTemp = visiteTemp.filter((v) => v.Esito < 1);
    }

    if (!f.arancione) {
      visiteTemp = visiteTemp.filter(
        (v) =>
          moment(v.Data).format("YYYY-MM-DD") <
          moment(new Date()).format("YYYY-MM-DD"),
      );
    }

    if (!f.alert) {
      visiteTemp = visiteTemp.filter((v) => v.Esito !== 3 && v.Esito !== 4);
    }

    setVisite(visiteTemp);

    /* let visiteTemp = visite.filter(v => v.Esito >=1);

setVisite(visiteTemp); */
  };

  const deleteVisita = async () => {
    try {
      await unsplash.delete("visiteMediche", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        data: {
          elencoVisite: visiteSelezionate,
        },
      });
      loadVisite(dal, al);
      setSnack({
        severity: "success",
        messaggio: "Eliminazione eseguita con successo",
      });
      setOpenSnack(true);
      //reloadVisite();
    } catch (error) {
      setSnack({
        severity: "error",
        messaggio:
          error?.response?.data?.message || "Errore durante l'eliminazione",
      });
      setOpenSnack(true);
    }
  };

  const hadleReport = async (type, visArr) => {
    let noEmailLav = [];
    let noEmailRef = [];
    let lav = [];
    let ref = [];
    if (visArr.length !== 0) {
      if (type === "dipendenti") {
        for (let i = 0; i < visArr.length; i++) {
          const vis = visArr[i];
          if (vis?.Email === null || vis?.Email === "") {
            noEmailLav = noEmailLav.every((e) => e.ID !== vis?.ID)
              ? [
                  ...noEmailLav,
                  {
                    nome: vis?.LavoratoreNome,
                    cognome: vis?.LavoratoreCognome,
                    cf: vis?.CF,
                    ID: vis?.ID,
                  },
                ]
              : [...noEmailLav.filter((f) => f.ID === vis?.ID)];
          } else {
            //let thereIsDigiuno = selectionModel.filter((sel) => sel.Digiuno === 1);
            //se la visita non esiste
            lav = lav.every((e) => e.ID !== vis?.ID)
              ? [
                  //aggiungo la visita tenendo lo storico dei lavoratori
                  ...lav,
                  {
                    ID: vis?.ID,
                    giorno: moment(vis?.Data).format("YYYY/MM/DD"),
                    ora: moment(vis?.Data).format("HH:mm"),
                    luogo: vis?.Luogo,
                    medico: vis?.Medico,
                    nome: vis?.LavoratoreNome,
                    cognome: vis?.LavoratoreCognome,
                    email: vis?.Email,
                    conter: vis?.Gruppo === "Conter" ? vis?.IDMansione : 0,
                    sede: vis?.SedeDesc,
                    cf: vis?.CF,
                    mansione: vis?.Mansione,
                    digiuno: vis?.Digiuno === 1 ? true : false,
                  },
                ]
              : [...lav.filter((ee) => ee.ID === vis?.ID)]; //altrimenti lascio invariato
          }
        }
        setReportReferenti(ref);
        setMissingEmailRef(noEmailRef);
        setReportLavoratori(lav);
        setMissingEmailLav(noEmailLav);

        setOpen(true);
        setLoadingEmail(true);
        if (lav.length !== 0) {
          try {
            await unsplash.post(
              "report",
              {
                type: "visiteMassive",
                dipendenti: lav,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                },
              },
            );
            setSnack({
              severity: "success",
              messaggio: "Report inviato con successo",
            });
            setOpenSnack(true);
          } catch (error) {
            setSnack({
              severity: "error",
              messaggio: "Errore durante l'invio del report",
            });
            setOpenSnack(true);
          }
        } else {
          setSnack({
            severity: "error",
            messaggio: "Controllare l'indirizzo email dei dipendenti",
          });
          setOpenSnack(true);
        }
        setLoadingEmail(false);
      } else {
        for (let i = 0; i < visArr.length; i++) {
          const vis = visArr[i];
          //se l'email del referente non esiste
          if (vis?.EmailReferente === null || vis?.EmailReferente === "") {
            noEmailRef = noEmailLav.every((e) => e.ID !== vis?.ID)
              ? [
                  ...noEmailLav,
                  {
                    ID: vis?.ID,
                    referente: vis?.Referente,
                    sede: vis?.SedeDesc,
                  },
                ]
              : [...noEmailLav.filter((f) => f.ID === vis?.ID)];
          } else {
            //controllo se è necessario il digiuno
            let dig =
              vis?.IDMansione === 1787 ||
              vis?.IDMansione === 1728 ||
              vis?.IDMansione === 1797 ||
              vis?.IDMansione === 1798 ||
              vis?.IDMansione === 1799 ||
              vis?.IDMansione === 763 ||
              vis?.IDMansione === 1800 ||
              vis?.IDMansione === 1801 ||
              vis?.IDMansione === 1792 ||
              vis?.IDMansione === 1793
                ? "SI"
                : vis?.Digiuno === 1
                  ? "SI"
                  : "NO";
            //se esiste aggiungo il referente con il relativo lavoratore all'interno
            if (ref.every((e) => e.email !== vis?.EmailReferente)) {
              ref = [
                ...ref,
                {
                  email: vis?.EmailReferente,
                  referente: vis?.Referente,
                  sede: vis?.SedeDesc,
                  lavoratori: [
                    {
                      ID: vis?.ID,
                      giorno: moment(vis?.Data).format("YYYY/MM/DD"),
                      ora: moment(vis?.Data).format("HH:mm"),
                      luogo: vis?.Luogo,
                      medico: vis?.Medico,
                      nome: vis?.LavoratoreNome,
                      cognome: vis?.LavoratoreCognome,
                      email: vis?.Email,
                      conter: vis?.Gruppo === "Conter" ? vis?.IDMansione : 0,
                      sede: vis?.SedeDesc,
                      cf: vis?.CF,
                      mansione: vis?.Mansione,
                      digiuno: dig,
                    },
                  ],
                  giorno: moment(vis?.Data).format("YYYY/MM/DD"),
                  ora: moment(vis?.Data).format("HH:mm"),
                  luogo: vis?.Luogo,
                  medico: vis?.Medico,
                  conter: vis?.Gruppo === "Conter" ? vis?.IDMansione : 0,
                },
              ];
            } else {
              const refFiltered = ref.filter(
                (r) => r.email === vis?.EmailReferente,
              );
              //altrimenti già il referente carico solo la visita all'interno del referente
              ref = [
                //lascio invariati gli oggetti dell'array che non hanno la stessa email referente
                ...ref.filter((r) => r.email !== vis?.EmailReferente),
                //prendo l'oggetto con la stessa email referente
                {
                  ...refFiltered[0],
                  //sovrascrivo la proprietà dei lavoratori aggiungendo la visita che sto iterando
                  lavoratori: refFiltered[0]?.lavoratori.every(
                    //se la visita non esiste la aggiungo
                    (e) => e.ID !== vis?.ID,
                  )
                    ? [
                        ...refFiltered[0]?.lavoratori,
                        {
                          ID: vis?.ID,
                          giorno: moment(vis?.Data).format("YYYY/MM/DD"),
                          ora: moment(vis?.Data).format("HH:mm"),
                          luogo: vis?.Luogo,
                          medico: vis?.Medico,
                          nome: vis?.LavoratoreNome,
                          cognome: vis?.LavoratoreCognome,
                          email: vis?.Email,
                          conter:
                            vis?.Gruppo === "Conter" ? vis?.IDMansione : 0,
                          sede: vis?.SedeDesc,
                          cf: vis?.CF,
                          mansione: vis?.Mansione,
                          digiuno: dig,
                        },
                      ]
                    : [
                        //altrimenti lascio invariato l'array dei lavoratori
                        ...refFiltered[0]?.lavoratori.filter(
                          (fe) => fe.ID === vis?.ID,
                        ),
                      ],
                },
              ];
            }
          }
        }
        setReportReferenti(ref);
        setMissingEmailRef(noEmailRef);

        setReportLavoratori(lav);
        setMissingEmailLav(noEmailLav);

        setOpen(true);
        setLoadingEmail(true);
        if (ref.length !== 0) {
          try {
            await unsplash.post(
              "report",
              {
                type: "visiteMassive",
                referenti: ref,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                },
              },
            );
            setSnack({
              severity: "success",
              messaggio: "Report inviato con successo",
            });
            setOpenSnack(true);
          } catch (error) {
            setSnack({
              severity: "error",
              messaggio: "Errore durante l'invio del report",
            });
            setOpenSnack(true);
          }
        } else {
          setSnack({
            severity: "error",
            messaggio: "Controllare l'indirizzo email del referente",
          });
          setOpenSnack(true);
        }
        setLoadingEmail(false);
      }
    } else {
      setMissingEmailLav([]);
      setMissingEmailRef([]);
      setReportReferenti([]);
      setReportLavoratori([]);
    }
  };

  const handleClose = () => {
    loadVisite(dal, al);
    setMissingEmailLav([]);
    setMissingEmailRef([]);
    setReportReferenti([]);
    setReportLavoratori([]);
    setOpen(false);
    setChangeDialog(false);
  };

  function renderToolbar() {
    return (
      <GridToolbarContainer>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          marginBottom={2}
        >
          <div className="w-full">
            <VisiteMedicheQuickFilter />
            <Checkbox
              icon={<HourglassDisabled />}
              checked={filtroClessidera.rosso}
              checkedIcon={<HourglassBottom />}
              sx={{ color: "#FF2768!important" }}
              onClick={(e) => filterClessidera(e, "rosso")}
            />
            <Checkbox
              icon={<HourglassDisabled />}
              checked={filtroClessidera.arancione}
              checkedIcon={<HourglassBottom />}
              sx={{ color: "#FFC897!important" }}
              onClick={(e) => filterClessidera(e, "arancione")}
            />
            <Checkbox
              icon={<HourglassDisabled />}
              checked={filtroClessidera.verde}
              checkedIcon={<HourglassBottom />}
              sx={{ color: "#40C18F!important" }}
              onClick={(e) => filterClessidera(e, "verde")}
            />
            <Checkbox
              icon={<ErrorOutline />}
              checked={filtroClessidera.alert}
              checkedIcon={<Error />}
              sx={{ color: "#FFC897!important" }}
              onClick={(e) => filterClessidera(e, "alert")}
            />
          </div>
          <div className="w-full flex h-fit">
            <ImportIdoneita onImported={() => loadVisite(dal, al)} />
            <Button
              variant="contained"
              size="small"
              onClick={printIdoneita}
              endIcon={<Print />}
              className="ButtonMillerTextWhite"
              sx={{ marginRight: "10px", marginLeft: "10px" }}
            >
              Stampa Idoneità
            </Button>
            <Button
              sx={{ marginRight: "10px" }}
              className="ButtonMillerTextWhite"
              size="small"
              endIcon={<InsertDriveFile />}
              variant={"contained"}
              onClick={() => document.getElementById("printDocVisite").click()}
            >
              Esporta in Excel
            </Button>
            {/* <div className="flex items-center w-fit"> */}
            <ButtonGroup
              variant="contained"
              className="mr-2"
              ref={anchorRefReport}
              aria-label="split button"
              style={{
                justifyItems: "center",
                display: visiteSelezionate.length > 0 ? "" : "None",
              }}
            >
              <Button
                size="small"
                startIcon={<Email />}
                variant="contained"
                className="ButtonMiller"
                onClick={handleToggleButtonReport}
              >
                REPORT
              </Button>
              <Button
                variant="contained"
                className="ButtonMiller"
                size="small"
                aria-controls={
                  openButtonReport ? "split-button-menu" : undefined
                }
                aria-expanded={openButtonReport ? "true" : undefined}
                aria-label="select merge strategy"
                aria-haspopup="menu"
                onClick={handleToggleButtonReport}
              >
                {openButtonReport ? <ArrowDropUp /> : <ArrowDropDownIcon />}
              </Button>
            </ButtonGroup>
            <Popper
              sx={{
                zIndex: 100,
              }}
              open={openButtonReport}
              anchorEl={anchorRefReport.current}
              role={undefined}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow {...TransitionProps}>
                  <Paper sx={{ ml: "10px" }}>
                    <ClickAwayListener onClickAway={handleCloseButtonReport}>
                      <MenuList id="split-button-menu" autoFocusItem>
                        {optionsReport.map((option, index) => (
                          <MenuItem
                            key={option}
                            selected={option.ind === selectedIndexReport}
                            onClick={(event) => {
                              handleMenuItemClickReport(event, option.ind);
                            }}
                          >
                            <span style={{ color: "#11526f" }}>
                              {option.icon} {option.text}
                            </span>
                          </MenuItem>
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
            <div style={{ display: "none" }}>
              <Button
                id="4"
                variant="contained"
                className="ButtonMiller"
                onClick={() => {
                  hadleReport("dipendenti", visiteSelezionate);
                  setOprionReport("dipendenti");
                }}
              >
                Dipendente
              </Button>

              <Button
                id="5"
                variant="contained"
                className="ButtonMiller"
                //sx={{ display: props.operation === "Edit" ? "" : "None" }}
                onClick={() => {
                  hadleReport("referenti", visiteSelezionate);
                  setOprionReport("referenti");
                }}
              >
                Referenti
              </Button>
            </div>
            {/* </div> */}
            <Button
              size="small"
              variant="contained"
              className="ButtonMillerError"
              style={{
                color: "white!important",
                display: visiteSelezionate.length > 0 ? "" : "None",
              }}
              startIcon={<Delete />}
              onClick={() => deleteVisita()}
            >
              {" "}
              Elimina
            </Button>
          </div>
        </Grid>
      </GridToolbarContainer>
    );
  }

  function filtraTutto(e, tipologia) {
    switch (tipologia) {
      case "Medico":
        if (
          e.target.value == "" &&
          filtroEtichette.Lavoratore == "" &&
          filtroEtichette.Mansione == "" &&
          filtroEtichette.Accertamenti == "" &&
          filtroEtichette.Cliente == "" &&
          filtroEtichette.Blocco == ""
        ) {
          setVisite(visiteBackup);
        } else {
          var visiteX = []; // popolo l'array
          var i;
          for (i = 0; i < visite.length; i++) {
            if (
              visite[i].Medico.toLowerCase().includes(
                e.target.value.toLowerCase(),
              )
            ) {
              visiteX.push(visite[i]);
            }
          }
          setVisite(visiteX);
          let f = { ...filtroEtichette };
          f.Medico = e.target.value;
          setFiltroEtichette(f);
        }
        break;

      case "Lavoratore":
        if (
          e.target.value == "" &&
          filtroEtichette.Medico == "" &&
          filtroEtichette.Mansione == "" &&
          filtroEtichette.Accertamenti == "" &&
          filtroEtichette.Cliente == "" &&
          filtroEtichette.Blocco == ""
        ) {
          setVisite(visiteBackup);
        } else {
          var visiteX = []; // popolo l'array
          var i;
          for (i = 0; i < visite.length; i++) {
            if (
              visite[i].LavoratoreNome.toLowerCase().includes(
                e.target.value.toLowerCase(),
              ) ||
              visite[i].LavoratoreCognome.toLowerCase().includes(
                e.target.value.toLowerCase(),
              )
            ) {
              visiteX.push(visite[i]);
            }
          }
          setVisite(visiteX);
          let f = { ...filtroEtichette };
          f.Lavoratore = e.target.value;
          setFiltroEtichette(f);
        }
        break;
      case "Mansione":
        if (
          e.target.value == "" &&
          filtroEtichette.Lavoratore == "" &&
          filtroEtichette.Medico == "" &&
          filtroEtichette.Accertamenti == "" &&
          filtroEtichette.Cliente == "" &&
          filtroEtichette.Blocco == ""
        ) {
          setVisite(visiteBackup);
        } else {
          var visiteX = []; // popolo l'array
          var i;
          for (i = 0; i < visite.length; i++) {
            if (
              visite[i].Mansione?.toLowerCase().includes(
                e.target.value.toLowerCase(),
              )
            ) {
              visiteX.push(visite[i]);
            }
          }
          setVisite(visiteX);
          let f = { ...filtroEtichette };
          f.Mansione = e.target.value;
          setFiltroEtichette(f);
        }
        break;
      case "Accertamenti":
        if (
          e.target.value == "" &&
          filtroEtichette.Lavoratore == "" &&
          filtroEtichette.Mansione == "" &&
          filtroEtichette.Medico == "" &&
          filtroEtichette.Cliente == "" &&
          filtroEtichette.Blocco == ""
        ) {
          setVisite(visiteBackup);
        } else {
          var visiteX = []; // popolo l'array
          var i;
          for (i = 0; i < visite.length; i++) {
            if (
              visite[i].Accertamenti?.toLowerCase().includes(
                e.target.value.toLowerCase(),
              )
            ) {
              visiteX.push(visite[i]);
            }
          }
          setVisite(visiteX);
          let f = { ...filtroEtichette };
          f.Accertamenti = e.target.value;
          setFiltroEtichette(f);
        }
        break;

      case "Cliente":
        if (
          e.target.value == "" &&
          filtroEtichette.Lavoratore == "" &&
          filtroEtichette.Mansione == "" &&
          filtroEtichette.Medico == "" &&
          filtroEtichette.Accertamenti == "" &&
          filtroEtichette.Blocco == ""
        ) {
          setVisite(visiteBackup);
        } else {
          var visiteX = []; // popolo l'array
          var i;
          for (i = 0; i < visite.length; i++) {
            if (
              visite[i].Cliente.toLowerCase().includes(
                e.target.value.toLowerCase(),
              )
            ) {
              visiteX.push(visite[i]);
            }
          }
          setVisite(visiteX);
          let f = { ...filtroEtichette };
          f.Cliente = e.target.value;
          setFiltroEtichette(f);
        }
        break;

      case "Blocco":
        if (
          e.target.value == "" &&
          filtroEtichette.Lavoratore == "" &&
          filtroEtichette.Mansione == "" &&
          filtroEtichette.Medico == "" &&
          filtroEtichette.Accertamenti == "" &&
          filtroEtichette.Cliente == ""
        ) {
          setVisite(visiteBackup);
        } else {
          var visiteX = []; // popolo l'array
          var i;
          for (i = 0; i < visite.length; i++) {
            if (
              visite[i].Blocco?.toLowerCase().includes(
                e.target.value.toLowerCase(),
              )
            ) {
              visiteX.push(visite[i]);
            }
          }
          setVisite(visiteX);
          let f = { ...filtroEtichette };
          f.Blocco = e.target.value;
          setFiltroEtichette(f);
        }
        break;
    }
  }

  const handleToggleButtonReport = () => {
    setOpenButtonReport(!openButtonReport);
  };

  const handleCloseButtonReport = (event) => {
    if (
      anchorRefReport.current &&
      anchorRefReport.current.contains(event.target)
    ) {
      return;
    }
    setOpenButtonReport(false);
  };

  const handleMenuItemClickReport = (event, index) => {
    document.getElementById(`${index}`).click();
    //setSelectedIndex(index);
    setOpenButtonReport(false);
  };

  return (
    <>
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Grid item xs={12}>
        <div style={{ display: "None" }}>
          <ReactHTMLTableToExcel
            id="printDocVisite"
            className="download-table-xls-button"
            table="table-to-xls"
            filename={"Log"}
            sheet={"Log"}
            style={{ display: "None!important" }}
            buttonText="Download Log"
          />
        </div>
        <table
          id="table-to-xls"
          style={{ marginTop: 10, display: "None" }}
          cellSpacing={0}
          border={0}
        >
          <thead>
            <tr>
              {[
                "Idoneità",
                "Cliente",
                "Cliente Attuale",
                "Categoria",
                "Cognome",
                "Nome",
                "Medico",
                "Mansione",
                "Accertamenti",
                "Esito",
                "Tipologia visita",
                "Data",
                "Scadenza",
                "CF",
                "Unità Produttiva",
                "Note",
              ].map((h) => (
                <th key={h}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visite?.map((visita) => (
              <tr key={visita.ID}>
                {[
                  visita.Idoneita === 0 ? "NO" : "SI",
                  visita.Cliente,
                  visita.ClienteAttuale,
                  visita.Categoria,
                  visita.LavoratoreCognome,
                  visita.LavoratoreNome,
                  visita.Medico,
                  visita.Mansione,
                  visita.Accertamenti,
                  visita.Esito === null ||
                  visita.Esito === undefined ||
                  visita.Esito === 0
                    ? "NO ESITO"
                    : visita.EsitoDesc,
                  visita.TipoVDesc,
                  moment(visita.Data).format("DD/MM/YYYY"),
                  visita.Scadenza
                    ? moment(visita.Scadenza).format("DD/MM/YYYY")
                    : "",
                  visita.CF,
                  visita.UnitaProduttivaAllegato3B,
                  visita.Note,
                ].map((cell, i) => (
                  <td key={i}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        <Card>
          <CardContent>
            <DateRangeFilters
              dal={dal}
              al={al}
              onApplyRange={handleApplyDateRange}
            />

            <DettaglioVisitaMedica
              operation="new"
              title={"nuova visita medica"}
              visita={visitaSel}
              esiti={esiti}
              tipologiaVisita={tipologiaVisita}
              mansioni={mansioni}
              medici={medici}
              updateData={updateData}
            />

            <Box
              sx={{ height: { xs: "75vh", md: "60vh", xl: "75vh" }, width: 1 }}
            >
              <DataGridPro
                initialState={{ pinnedColumns: { left: ["Actions"] } }}
                sx={{
                  ".MuiDataGrid-columnHeaderCheckbox ": { display: "none" },
                  ".MuiDataGrid-cellCheckbox": { display: "none" },
                  fontSize: 12,
                }}
                components={{
                  Toolbar: VisiteMedicheToolbar,
                  Footer: CustomFooterPersonalized,
                }}
                componentsProps={{ toolbar: { children: renderToolbar() } }}
                localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
                slots={{
                  loadingOverlay: LinearProgress,
                }}
                loading={loading}
                rows={visite}
                columns={columns}
                getRowId={(row) => row.ID}
                pageSize={100}
                checkboxSelection
                onSelectionModelChange={(ids) => {
                  const selectedIDs = new Set(ids);
                  const selectedRowData = visite.filter((row) =>
                    selectedIDs.has(row.ID),
                  );
                  setVisiteSelezionate(selectedRowData);
                  let dataAPI = selectedRowData.map((v) => {
                    return {
                      IDMansione: v.IDMansione,
                      Data: v.Data,
                      IDCliente: v.IDCliente,
                      ID: v.ID,
                    };
                  });
                  setVisiteSelezionateAPI(dataAPI);
                }}
                onCellClick={(params, e) => {
                  if (params.field === "Actions") {
                    e.stopPropagation();
                  }
                }}
                /* onRowDoubleClick={async (params, event) => {
                      await setVisitaSel(params.row);
                      document.getElementById("myDialog").click();
                    }} */
              />
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        TransitionComponent={Transition}
      >
        {/* Title Container */}
        <DialogTitle
          sx={{
            mx: "auto",
          }}
        >
          Resoconto Invio Report
        </DialogTitle>
        {/* Body Container */}
        <DialogContent className="max-h-60 md:max-h-96 overflow-auto h-full w-full ">
          {loadingEmail ? (
            <div className="flex justify-center">
              <CircularProgress />
            </div>
          ) : (
            <>
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "whitesmoke" }} />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography sx={{ width: "40%" }}>
                    Email inviate ai {optionReport}:
                  </Typography>
                  <b style={{ width: "5%" }}>
                    {optionReport === "dipendenti"
                      ? reportLavoratori.length
                      : reportReferenti.length}
                  </b>
                  {optionReport === "dipendenti" ? (
                    <>
                      {reportLavoratori.length !== 0 ? (
                        <Circle
                          sx={{
                            color: "#40C18F",
                          }}
                        >
                          {" "}
                        </Circle>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <>
                      {reportReferenti.length !== 0 ? (
                        <Circle
                          sx={{
                            color: "#40C18F",
                          }}
                        >
                          {" "}
                        </Circle>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </AccordionSummary>
                <AccordionDetails>
                  {optionReport === "dipendenti" ? (
                    <>
                      {reportLavoratori.length > 0 ? (
                        <>
                          {reportLavoratori.map((el, index) => (
                            <div key={index}>
                              -
                              <b>
                                {el.cf === "" || el.cf === null
                                  ? "Senza CF"
                                  : el.cf + ", " + el.cognome + " " + el.nome}
                              </b>
                            </div>
                          ))}
                        </>
                      ) : (
                        <>
                          <div className="text-lg">Nessuna email inviata</div>
                          <div className="">
                            Controllare gli indirizzi inseriti!
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {reportReferenti.length > 0 ? (
                        <>
                          {reportReferenti.map((el, index) => (
                            <div key={index}>
                              -
                              <b>
                                {el.referente === "" || el.referente === null
                                  ? "Senza nome" + ", " + el.sede
                                  : el.referente + ", " + el.sede}
                              </b>
                            </div>
                          ))}
                        </>
                      ) : (
                        <>
                          <div className="text-lg">Nessuna email inviata</div>
                          <div className="">
                            Controllare gli indirizzi inseriti!
                          </div>
                        </>
                      )}
                    </>
                  )}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "whitesmoke" }} />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <Typography sx={{ width: "40%" }}>
                    Email mancanti {optionReport}:
                  </Typography>
                  <b style={{ width: "5%" }}>
                    {optionReport === "dipendenti"
                      ? missingEmailLav.length
                      : missingEmailRef.length}
                  </b>
                  {optionReport === "dipendenti" ? (
                    <>
                      {missingEmailLav.length !== 0 ? (
                        <Circle
                          sx={{
                            color: "#FF2768",
                          }}
                        >
                          {" "}
                        </Circle>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <>
                      {missingEmailRef.length !== 0 ? (
                        <Circle
                          sx={{
                            color: "#FF2768",
                          }}
                        >
                          {" "}
                        </Circle>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </AccordionSummary>
                <AccordionDetails>
                  {optionReport === "dipendenti" ? (
                    <>
                      {missingEmailLav.length > 0 ? (
                        <>
                          {missingEmailLav.map((el, index) => (
                            <div key={index}>
                              -
                              <b>
                                {el.cf === "" || el.cf === null
                                  ? "Senza CF" +
                                    ", " +
                                    el.cognome +
                                    " " +
                                    el.nome
                                  : el.cf + ", " + el.cognome + " " + el.nome}
                              </b>
                            </div>
                          ))}
                        </>
                      ) : (
                        <>
                          <div className="text-lg">Nessuna email inviata</div>
                          <div className="">
                            Controllare gli indirizzi inseriti!
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {missingEmailRef.length > 0 ? (
                        <>
                          {missingEmailRef.map((el, index) => (
                            <div key={index}>
                              -
                              <b>
                                {el.referente === "" || el.referente === null
                                  ? "Senza nome" + ", " + el.sede
                                  : el.referente + ", " + el.sede}
                              </b>
                            </div>
                          ))}
                        </>
                      ) : (
                        <>
                          <div className="text-lg">Nessuna email inviata</div>
                          <div className="">
                            Controllare gli indirizzi inseriti!
                          </div>
                        </>
                      )}
                    </>
                  )}
                </AccordionDetails>
              </Accordion>
            </>
          )}
        </DialogContent>
        <DialogActions
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mx: 2,
          }}
        >
          <Button
            onClick={handleClose}
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
          >
            Chiudi
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VisiteMediche;

const DettaglioVisitaMedica = (props) => {
  const [open, setOpen] = useState(false);
  const [accertamenti, setAccertamenti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectionModel, setSelectionModel] = useState([]);
  const [required, setRequired] = useState({
    medico: false,
    data: false,
    tipo: false,
  });
  const [openSnack, setOpenSnack] = useState(false);
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });
  const [visita, setVisita] = useState(null);
  const [orario, setOrario] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const columns = [
    {
      field: "Descrizione",
      headerName: "Accertamento",
      width: 300,
      renderCell: renderAccertamentoVisitaCell,
    },
    {
      field: "Scadenza",
      headerName: "Scadenza",
      type: "date",
      width: 150,
      editable: true,

      renderCell: (params) =>
        params.row.Scadenza
          ? moment(params.row.Scadenza).format("DD/MM/YYYY")
          : "",
    },
    {
      field: "Importo",
      headerName: "Importo €",
      type: "number",
      width: 120,
      editable: false,
      renderCell: (params) => (params.row.Importo ? params.row.Importo : 0),
    },
    {
      field: "ImportoPassivo",
      headerName: "Importo Passivo €",
      type: "number",
      width: 150,
      editable: false,
      renderCell: (params) =>
        params.row.ImportoPassivo ? params.row.ImportoPassivo : 0,
    },
  ];

  const optionsReport = [
    {
      icon: <GroupsIcon />,
      text: "DIPENDENTI",
      ind: 4,
    },
    {
      icon: <Person />,
      text: "REFERENTI",
      ind: 5,
    },
  ];

  const loadAccertamenti = async (val, data, cliente) => {
    let responseAccertamenti = await unsplash.get("accertamenti", {
      params: { id: val, data: data, clienteAcc: cliente },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    const acc = responseAccertamenti.data.data;
    const selectedAcc = acc.filter((element) =>
      element.VisitaMedica ? element.ID : null,
    );
    setSelectionModel(selectedAcc);
    const orderedAcc = [
      ...acc.filter((element) => element.VisitaMedica),
      ...acc.filter((element) => !element.VisitaMedica),
    ];
    setAccertamenti(orderedAcc);
    setLoading(false);
  };

  const handleClickOpen = async () => {
    if (document.activeElement?.blur) {
      document.activeElement.blur();
    }
    setVisita(props.visita);
    setAccertamenti([]);

    await loadAccertamenti(
      props.visita.ID,
      moment(props.visita.Data).format("YYYY-MM-DD"),
      props.visita.IDCliente,
    );

    await setRequired({ medico: false, data: false, tipo: false });
    setOrario(props.visita.Data);
    setOpen(true);
  };

  const handleClose = () => {
    if (document.activeElement?.blur) {
      document.activeElement.blur();
    }
    setOpen(false);
    setVisita(null);
  };

  const handleSave = async () => {
    if (isSaving) {
      return;
    }
    setIsSaving(true);

    let vis = { ...visita };
    vis.Data = vis.Data
      ? moment(vis.Data).format("YYYY-MM-DD") +
        " " +
        moment(orario).format("HH:mm:ss")
      : null;
    props.updateData(vis, selectionModel);
    try {
      await unsplash.put(
        "visiteMediche",
        { visita: vis, accertamenti: selectionModel },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        },
      );
      setSnack({
        severity: "success",
        messaggio: "Visita Medica modificata con successo",
      });
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante il salvataggio della visita medica",
      });
    } finally {
      setOpenSnack(true);
      setIsSaving(false);
    }
  };

  const handleReorderCheck = async () => {
    let IDSelected = selectionModel.map((s) => s.ID);

    let top = [];
    let bottom = [];
    for (let i = 0; i < accertamenti.length; i++) {
      if (IDSelected.indexOf(accertamenti[i].ID) >= 0) {
        top.push(accertamenti[i]);
      } else {
        bottom.push(accertamenti[i]);
      }
    }

    setAccertamenti(top.concat(bottom));
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          gap={2}
        >
          <GridToolbarQuickFilter placeholder="Cerca..." />
          <Button
            size="small"
            onClick={() => handleReorderCheck()}
            startIcon={<CheckBox />}
          >
            Riordina{" "}
          </Button>
        </Grid>
      </GridToolbarContainer>
    );
  }

  const handleOrarioChange = (event) => {
    let d = { ...visita };
    setOrario(event); //.format("HH:mm")
    //utilizzo la forma abbreviata della condizione if (Guard clauses)
    if (event) {
      d.Data =
        moment(visita.Data).format("YYYY-MM-DD") +
        " " +
        event.format("HH:mm:ss");
    }
  };

  const idsAccertamentiSelezionati = new Set(
    (selectionModel || []).map((sel) => sel.ID),
  );
  const accertamentiRaggruppati = buildAccertamentiVisitaRows(
    accertamenti,
    idsAccertamentiSelezionati,
    selectionModel,
  );
  const selectionModelGriglia = getAccertamentiVisitaSelectionRowIds(
    accertamentiRaggruppati,
    idsAccertamentiSelezionati,
  );

  return (
    <div>
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Button
        variant="outlined"
        style={{ display: "None" }}
        onClick={handleClickOpen}
        id="myDialog"
      >
        Nuovo
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        TransitionComponent={Transition}
      >
        <DialogTitle>
          {"Modifica Visita " +
            props.visita.LavoratoreCognome +
            " " +
            props.visita.LavoratoreNome +
            " - " +
            props.visita.Cliente}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {required.tipo || required.data || required.medico ? (
                    <p style={{ color: "#FF2768" }}>
                      controlla i campi obbligatori!
                    </p>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth error={required.medico}>
                    <InputLabel id="demo-simple-select-label">
                      Medico
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={
                        visita &&
                        props.medici?.some(
                          (medico) => medico.ID === visita.IDMedico,
                        )
                          ? visita.IDMedico
                          : ""
                      }
                      label="Medico"
                      onChange={(e) => {
                        let medico = props.medici.filter(
                          (medico) => medico.ID === e.target.value,
                        )[0];
                        let text = medico.Nome + " " + medico.Cognome;
                        let v = { ...visita };
                        v.IDMedico = e.target.value;
                        v.Medico = text;
                        setVisita(v);
                      }}
                    >
                      {props.medici?.map((medico) =>
                        medico.ID !== -1 ? (
                          <MenuItem key={medico.ID} value={medico.ID}>
                            {medico.Nome + " " + medico.Cognome}
                          </MenuItem>
                        ) : null,
                      )}
                    </Select>
                    {required.medico ? (
                      <FormHelperText>Medico obbligatorio</FormHelperText>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      ampmInClock={false}
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          error: required.data,
                        },
                      }}
                      label="Data"
                      value={visita ? moment(visita.Data) : null}
                      onChange={(newValue) => {
                        let v = { ...visita };
                        if (newValue) {
                          v.Data = newValue.format("YYYY-MM-DD HH:mm:SS");
                        }
                        setVisita(v);
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <TimePicker
                      ampmInClock={false}
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          error: required.ora,
                        },
                      }}
                      label="Ora"
                      value={orario ? moment(orario) : null}
                      onChange={handleOrarioChange}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth error={required.data}>
                    <InputLabel id="demo-simple-select-label">
                      Mansione
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={
                        visita &&
                        props.mansioni?.some(
                          (mansione) => mansione.ID === visita.IDMansione,
                        )
                          ? visita.IDMansione
                          : ""
                      }
                      label="Mansione"
                      onChange={(e) => {
                        let text = props.mansioni.filter(
                          (mansione) => mansione.ID === e.target.value,
                        )[0].Descrizione;
                        let v = { ...visita };
                        v.IDMansione = e.target.value;
                        v.Mansione = text;
                        setVisita(v);
                      }}
                    >
                      {props.mansioni?.map((mansione) => (
                        <MenuItem key={mansione.ID} value={mansione.ID}>
                          {mansione.Descrizione}
                        </MenuItem>
                      ))}
                    </Select>
                    {required.data ? (
                      <FormHelperText>Mansione obbligatoria</FormHelperText>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth error={required.tipo}>
                    <InputLabel id="demo-simple-select-label">
                      Tipologia Visita
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={
                        visita &&
                        props.tipologiaVisita?.some(
                          (tipologia) => tipologia.ID === visita.TipoVisita,
                        )
                          ? visita.TipoVisita
                          : ""
                      }
                      label="Tipologia Visita"
                      onChange={(e) => {
                        let text = props.tipologiaVisita.filter(
                          (tipologia) => tipologia.ID === e.target.value,
                        )[0].Descrizione;
                        let v = { ...visita };
                        v.TipoVisita = e.target.value;
                        v.TipoVDesc = text;
                        setVisita(v);
                      }}
                    >
                      {props.tipologiaVisita?.map((tipologia) => (
                        <MenuItem key={tipologia.ID} value={tipologia.ID}>
                          {tipologia.Descrizione}
                        </MenuItem>
                      ))}
                    </Select>
                    {required.tipo ? (
                      <FormHelperText>Tipologia obbligatoria</FormHelperText>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Luogo"
                    multiline
                    value={visita?.Luogo ?? ""}
                    onChange={(e) => {
                      let v = { ...visita };
                      v.Luogo = e.target.value;
                      setVisita(v);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <div style={{ height: 400, width: "100%" }}>
                    <DataGridPro
                      initialState={{ pinnedColumns: { left: ["Actions"] } }}
                      components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooterPersonalized,
                      }}
                      slots={{
                        loadingOverlay: LinearProgress,
                      }}
                      loading={loading}
                      disableSelectionOnClick
                      disableColumnSorting
                      checkboxSelection
                      disableColumnMenu={true}
                      localeText={
                        itIT.components.MuiDataGrid.defaultProps.localeText
                      }
                      rows={accertamentiRaggruppati}
                      getRowId={getAccertamentiVisitaRowId}
                      columns={columns}
                      selectionModel={selectionModelGriglia}
                      onSelectionModelChange={(ids) => {
                        // guardiamo solo cosa è stato aggiunto/tolto rispetto
                        // a prima, per non "promuovere" a piena selezione un
                        // gruppo solo parzialmente selezionato senza che
                        // l'utente lo tocchi (altrimenti il totale aggregato
                        // include esami mai effettivamente scelti)
                        const { aggiunti, rimossi } =
                          getAccertamentiVisitaSelectionChanges(
                            accertamentiRaggruppati,
                            ids,
                            selectionModelGriglia,
                          );
                        const { selectedRows } =
                          getAccertamentiVisitaSelectedRows(
                            selectionModel,
                            accertamenti,
                            aggiunti,
                            rimossi,
                          );

                        setSelectionModel(selectedRows);
                      }}
                      onCellEditCommit={(params) => {
                        const rowId = params?.id ?? params?.row?.ID;
                        if (rowId == null) {
                          return;
                        }
                        const gruppo = accertamentiRaggruppati.find(
                          (r) =>
                            String(getAccertamentiVisitaRowId(r)) ===
                            String(rowId),
                        );
                        const idsDaAggiornare = (gruppo?._ids ?? [rowId]).map(
                          String,
                        );

                        const formattedValue =
                          params.field === "Scadenza"
                            ? params.value
                              ? moment
                                  .utc(params.value)
                                  .local()
                                  .format("YYYY-MM-DD")
                              : null
                            : params.value;
                        const idsDaAggiornareSet = new Set(idsDaAggiornare);

                        let selAcc = Array.isArray(selectionModel)
                          ? [...selectionModel]
                          : [];
                        idsDaAggiornare.forEach((id) => {
                          const baseRow =
                            accertamenti.find(
                              (acc) => String(acc?.ID) === id,
                            ) || {};
                          let row = { ...baseRow, ID: baseRow.ID ?? id };
                          row[params.field] = formattedValue;

                          let findIndex = selAcc.findIndex(
                            (acc) => String(acc?.ID) === id,
                          );
                          if (findIndex !== -1) {
                            selAcc[findIndex] = {
                              ...selAcc[findIndex],
                              ...row,
                            };
                          } else {
                            selAcc.push(row);
                          }
                        });
                        setAccertamenti((current) =>
                          (current || []).map((acc) =>
                            idsDaAggiornareSet.has(String(acc?.ID))
                              ? {
                                  ...acc,
                                  [params.field]: formattedValue,
                                }
                              : acc,
                          ),
                        );
                        setSelectionModel(selAcc);
                      }}
                    />
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Esito</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={
                        visita
                          ? visita.Esito === null ||
                            visita.Esito === undefined ||
                            visita.Esito === 0
                            ? ""
                            : visita.Esito
                          : ""
                      }
                      label="Esito"
                      onChange={(e) => {
                        let v = { ...visita };
                        if (e.target.value === "") {
                          v.Esito = null;
                          v.EsitoDesc = "NO ESITO";
                        } else {
                          const found = props.esiti?.find(
                            (esito) => esito.ID === e.target.value,
                          );
                          v.Esito = e.target.value;
                          v.EsitoDesc = found?.Descrizione || "";
                        }
                        setVisita(v);
                      }}

                      //onChange={handleChange}
                    >
                      <MenuItem value="">NO ESITO</MenuItem>
                      {props.esiti?.map((esito) => (
                        <MenuItem key={esito.ID} value={esito.ID}>
                          {esito.Descrizione}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Note"
                    multiline
                    value={visita?.Note ?? ""}
                    onChange={(e) => {
                      let v = { ...visita };
                      v.Note = e.target.value;
                      setVisita(v);
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mx: 2,
          }}
        >
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            onClick={handleClose}
          >
            Esci
          </Button>
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Check />}
            onClick={handleSave}
            disabled={isSaving}
            color="success"
          >
            Salva
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const ImportIdoneita = ({ onImported }) => {
  const [open, setOpen] = useState(false);
  const {
    acceptedFiles,
    isDragAccept,
    isDragReject,
    isFocused,
    getRootProps,
    getInputProps,
  } = useDropzone();
  const [files, setFiles] = useState([]);
  const [analysis, setAnalysis] = useState(null);
  const [analysisJobId, setAnalysisJobId] = useState(null);
  const [analysisStatus, setAnalysisStatus] = useState(null);
  const [confirmStatus, setConfirmStatus] = useState(null);
  const [confirmProposalsReviewed, setConfirmProposalsReviewed] =
    useState(false);
  const [importing, setImporting] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });
  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  };

  const focusedStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject],
  );

  const proposedVisite = useMemo(() => {
    if (!Array.isArray(analysis)) return [];
    const items = [];
    analysis.forEach((fileAnalysis) => {
      const pages = Array.isArray(fileAnalysis?.pageAnalyses)
        ? fileAnalysis.pageAnalyses
        : [];
      pages.forEach((pageAnalysis) => {
        const proposedVisitaId = Number(pageAnalysis?.proposedVisitaId || 0);
        if (!Number.isFinite(proposedVisitaId) || proposedVisitaId <= 0) return;
        const candidates = Array.isArray(pageAnalysis?.openVisiteCandidates)
          ? pageAnalysis.openVisiteCandidates
          : [];
        const matchedCandidate =
          candidates.find((c) => Number(c?.id || 0) === proposedVisitaId) ||
          candidates[0] ||
          null;
        items.push({
          key: `${fileAnalysis?.originalName || "file"}-${pageAnalysis?.page || 0}-${proposedVisitaId}`,
          file: fileAnalysis?.originalName || "",
          page: Number(pageAnalysis?.page || 0),
          visitaId: proposedVisitaId,
          data: matchedCandidate?.data || null,
          nome: matchedCandidate?.nome || "",
          cognome: matchedCandidate?.cognome || "",
          cliente: matchedCandidate?.cliente || "",
          cf: matchedCandidate?.cf || pageAnalysis?.cf || "",
        });
      });
    });
    return items;
  }, [analysis]);
  const requiresProposalConfirmation = proposedVisite.length > 0;

  const handleUpload = async () => {
    if (files.length === 0) {
      setSnack({ severity: "error", messaggio: "Nessun file selezionato" });
      setOpenSnack(true);
    } else {
      try {
        // Step 1: avvia analisi (non salva su SFTP/DB) e mostra avanzamento via polling
        if (!analysisJobId) {
          const formData = new FormData();
          files.forEach((file) => formData.append("file", file));
          const resp = await unsplash.post("idoneita/analyzeStart", formData, {
            headers: {
              "content-type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          });
          setAnalysisJobId(resp.data?.jobId || null);
          setAnalysisStatus({
            phase: "queued",
            done: false,
            pagesTotal: 0,
            pagesProcessed: 0,
          });
          setSnack({
            severity: "info",
            messaggio: "Analisi avviata. Attendi il completamento.",
          });
          setOpenSnack(true);
          return;
        }

        // Se stiamo ancora analizzando, non fare nulla.
        if (!analysis) {
          return;
        }
        if (requiresProposalConfirmation && !confirmProposalsReviewed) {
          setSnack({
            severity: "warning",
            messaggio:
              "Conferma prima i nominativi delle visite proposte per procedere.",
          });
          setOpenSnack(true);
          return;
        }

        // Step 2: conferma import
        setImporting(true);
        setConfirmStatus({
          progress: {
            running: true,
            phase: "running",
            totalFiles: files.length,
            processedFiles: 0,
            totalPages: 0,
            processedPages: 0,
            current: null,
          },
        });
        const confirmResp = await unsplash.post(
          "idoneita/confirm",
          { jobId: analysisJobId },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        );
        if (typeof onImported === "function") {
          try {
            onImported(confirmResp?.data || null);
          } catch (_) {}
        }
        const zipUrl = confirmResp?.data?.zip?.url;
        const zipFileName =
          confirmResp?.data?.zip?.fileName?.split("/")?.pop() || "idoneita.zip";
        const summary = confirmResp?.data?.summary || {};
        const linkedToVisite = Number(summary?.linkedToVisite || 0);
        const anomalies = Number(summary?.anomalies || 0);
        const zipError = confirmResp?.data?.zipError || null;

        if (zipUrl) {
          try {
            const zipResp = await fetch(zipUrl);
            if (!zipResp.ok) {
              throw new Error(`HTTP ${zipResp.status}`);
            }
            const zipBlob = await zipResp.blob();
            const blobUrl = window.URL.createObjectURL(zipBlob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", zipFileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => window.URL.revokeObjectURL(blobUrl), 30_000);
          } catch (_) {
            window.open(zipUrl, "_blank", "noopener,noreferrer");
          }
        }

        let severity = "success";
        let messaggio = "Import completato con successo";
        if (linkedToVisite === 0) {
          severity = "warning";
          messaggio =
            "Import completato, ma nessuna idoneità è stata associata a visite aperte (verifica le anomalie).";
        } else if (!zipUrl) {
          severity = "warning";
          messaggio = zipError
            ? `Import completato (${linkedToVisite} associate), ma ZIP non disponibile: ${zipError}`
            : `Import completato (${linkedToVisite} associate), ma ZIP non disponibile.`;
        } else if (anomalies > 0) {
          messaggio = `Import completato: ${linkedToVisite} associate, ${anomalies} in anomalia.`;
        } else {
          messaggio =
            "Import completato. Download dello ZIP con le idoneità associate avviato.";
        }

        setSnack({
          severity,
          messaggio,
        });
        setOpenSnack(true);
        setOpen(false);
        setFiles([]);
        setAnalysis(null);
        setAnalysisJobId(null);
        setConfirmStatus(null);
      } catch {
        setSnack({
          severity: "error",
          messaggio: "Errore durante analisi/import",
        });
        setOpenSnack(true);
      } finally {
        setImporting(false);
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
    setFiles([]);
    setAnalysis(null);
    setAnalysisJobId(null);
    setAnalysisStatus(null);
    setConfirmStatus(null);
    setConfirmProposalsReviewed(false);
  };
  const onDrop = (acceptedFiles) => {
    setFiles(acceptedFiles);
    setAnalysis(null);
    setAnalysisJobId(null);
    setAnalysisStatus(null);
    setConfirmStatus(null);
    setConfirmProposalsReviewed(false);
  };

  useEffect(() => {
    if (!analysisJobId || analysis) {
      return;
    }

    let cancelled = false;
    const timer = setInterval(async () => {
      try {
        const resp = await unsplash.get("idoneita/analyzeStatus", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          params: { jobId: analysisJobId },
        });
        if (cancelled) return;
        setAnalysisStatus(resp.data || null);
        if (resp.data?.done) {
          clearInterval(timer);
          if (resp.data?.analysis) {
            setAnalysis(resp.data.analysis);
            setSnack({
              severity: resp.data?.ok === false ? "error" : "info",
              messaggio:
                resp.data?.ok === false
                  ? `Analisi fallita: ${resp.data?.error || "errore"}`
                  : "Analisi completata. Se il risultato ti torna, premi 'Procedi'.",
            });
            setOpenSnack(true);
          } else if (resp.data?.ok === false) {
            setSnack({
              severity: "error",
              messaggio: `Analisi fallita: ${resp.data?.error || "errore"}`,
            });
            setOpenSnack(true);
          }
        }
      } catch {
        // ignoriamo errori transienti nel polling
      }
    }, 800);

    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [analysisJobId, analysis]);

  useEffect(() => {
    if (!importing || !analysisJobId) {
      return;
    }
    let cancelled = false;
    const timer = setInterval(async () => {
      try {
        const resp = await unsplash.get("idoneita/confirmStatus", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          params: { jobId: analysisJobId },
        });
        if (cancelled) return;
        setConfirmStatus(resp.data?.confirm || null);
      } catch {
        // best-effort polling
      }
    }, 800);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [importing, analysisJobId]);

  return (
    <>
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Button
        className="ButtonMillerTextWhite"
        size="small"
        endIcon={<UploadFile />}
        variant={"contained"}
        onClick={() => {
          setOpen(true);
          setFiles([]);
          setAnalysis(null);
          setAnalysisJobId(null);
          setAnalysisStatus(null);
          setConfirmStatus(null);
          setConfirmProposalsReviewed(false);
        }}
        sx={{ color: "white!important" }}
      >
        Importa Idoneità
      </Button>

      <>
        <Dialog
          open={open}
          onClose={handleClose}
          TransitionComponent={Transition}
        >
          <DialogTitle>Carica File</DialogTitle>
          <DialogContent>
            <Dropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles)}>
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps({ style })}>
                  <input {...getInputProps()} />
                  <p>
                    Trascina e rilascia qui o fai clic per selezionare i file
                  </p>
                </div>
              )}
            </Dropzone>
            <aside>
              <h4 style={{ marginTop: "10px", textAlign: "center" }}>Files</h4>
              {files?.map((file) => {
                return (
                  <div
                    key={file.path || file.name}
                    style={{ textAlign: "center", padding: 0 }}
                  >
                    {file.path}
                  </div>
                );
              })}
            </aside>

            {analysisJobId && !analysis ? (
              <div style={{ marginTop: 16 }}>
                <h4 style={{ textAlign: "center" }}>Analisi in corso</h4>
                {analysisStatus?.pagesTotal > 0 ? (
                  <>
                    <LinearProgress
                      variant="determinate"
                      value={Math.min(
                        100,
                        (Number(analysisStatus?.pagesProcessed || 0) /
                          Number(analysisStatus?.pagesTotal || 1)) *
                          100,
                      )}
                    />
                    <div style={{ textAlign: "center", marginTop: 6 }}>
                      {analysisStatus?.pagesProcessed || 0}/
                      {analysisStatus?.pagesTotal || 0} pagine
                    </div>
                    {analysisStatus?.current?.step ? (
                      <div style={{ textAlign: "center", marginTop: 4 }}>
                        {analysisStatus.current.step === "decode"
                          ? "Ricerca barcode/QR in corso..."
                          : analysisStatus.current.step === "decode_render"
                            ? "Preparazione immagini (barcode/QR)..."
                            : analysisStatus.current.step === "cf"
                              ? "Barcode non trovati: lettura testo/OCR (CF) in corso..."
                              : analysisStatus.current.step === "prepare"
                                ? "Preparazione PDF..."
                                : `Step: ${analysisStatus.current.step}`}
                      </div>
                    ) : (
                      ""
                    )}
                    {analysisStatus?.current?.page ? (
                      <div style={{ textAlign: "center", marginTop: 4 }}>
                        {analysisStatus?.current?.file
                          ? `${analysisStatus.current.file} - `
                          : ""}
                        pagina {analysisStatus.current.page}
                        {analysisStatus?.current?.pageEnd
                          ? `-${analysisStatus.current.pageEnd}`
                          : ""}
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  <>
                    <LinearProgress />
                    <div style={{ textAlign: "center", marginTop: 6 }}>
                      Preparazione...
                    </div>
                  </>
                )}
              </div>
            ) : (
              ""
            )}

            {analysis ? (
              <div style={{ marginTop: 16 }}>
                <h4 style={{ textAlign: "center" }}>Analisi</h4>
                {analysis.map((a) => (
                  <div key={a.originalName} style={{ marginBottom: 12 }}>
                    <b>{a.originalName}</b>
                    <div>Pagine: {a.pages}</div>
                    <div>Pagine con QR letto: {a.decodedQrPages}</div>
                    <div>
                      <b>Anomalie (pagine senza lettura):</b>{" "}
                      {a.unreadPages || 0}
                    </div>
                    <div>Visite trovate (uniche): {a.uniqueVisite}</div>
                    <div>
                      Pagine con CF rilevato:{" "}
                      {a.pageAnalyses?.filter((p) => p.cf)?.length || 0}
                    </div>
                    <div>
                      Pagine con proposta visita:{" "}
                      {a.pageAnalyses?.filter((p) => p.proposedVisitaId)
                        ?.length || 0}
                    </div>
                    {a.visite?.length ? (
                      <div style={{ marginTop: 6, fontSize: 13 }}>
                        {a.visite.map((v) => (
                          <div key={v.visitaId}>
                            {v.found ? "OK" : "MANCANTE"} Visita {v.visitaId}
                            {v.found && v.nome
                              ? ` - ${v.nome} ${v.cognome}`
                              : ""}
                          </div>
                        ))}
                      </div>
                    ) : (
                      ""
                    )}
                    {a.nonNumericCodes?.length ? (
                      <div style={{ marginTop: 6, color: "#b71c1c" }}>
                        QR non numerici: {a.nonNumericCodes.length}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ))}
                <div style={{ textAlign: "center", fontSize: 13 }}>
                  Job: {analysisJobId}
                </div>
                {requiresProposalConfirmation ? (
                  <div
                    style={{
                      marginTop: 10,
                      padding: 10,
                      border: "1px solid #f0ad4e",
                      borderRadius: 6,
                      background: "#fff8e1",
                      fontSize: 13,
                    }}
                  >
                    <div style={{ fontWeight: 600, marginBottom: 6 }}>
                      Verifica manuale obbligatoria: visite proposte
                    </div>
                    {proposedVisite.map((p) => (
                      <div key={p.key} style={{ marginBottom: 4 }}>
                        {p.file ? `${p.file} - ` : ""}
                        pag. {p.page || "-"} - visita {p.visitaId}
                        {p.data
                          ? ` (${moment(p.data).format("DD/MM/YYYY")})`
                          : ""}
                        {p.nome || p.cognome
                          ? ` - ${p.nome} ${p.cognome}`.trim()
                          : ""}
                        {p.cf ? ` - CF ${p.cf}` : ""}
                        {p.cliente ? ` - ${p.cliente}` : ""}
                      </div>
                    ))}
                    <div style={{ marginTop: 8 }}>
                      <Checkbox
                        checked={confirmProposalsReviewed}
                        onChange={(e) =>
                          setConfirmProposalsReviewed(e.target.checked)
                        }
                        disabled={importing}
                      />
                      Confermo i nominativi e le visite proposte sopra
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}

            {importing ? (
              <div style={{ marginTop: 16 }}>
                <h4 style={{ textAlign: "center" }}>Import in corso</h4>
                {Number(confirmStatus?.progress?.totalPages || 0) > 0 ? (
                  <LinearProgress
                    variant="determinate"
                    value={Math.min(
                      100,
                      (Number(confirmStatus?.progress?.processedPages || 0) /
                        Math.max(
                          1,
                          Number(confirmStatus?.progress?.totalPages || 1),
                        )) *
                        100,
                    )}
                  />
                ) : (
                  <LinearProgress />
                )}
                <div style={{ textAlign: "center", marginTop: 6 }}>
                  Sto caricando e associando le idoneita...
                </div>
                <div
                  style={{ textAlign: "center", marginTop: 4, fontSize: 13 }}
                >
                  File: {Number(confirmStatus?.progress?.processedFiles || 0)}/
                  {Number(confirmStatus?.progress?.totalFiles || 0)}
                  {" - "}
                  Pagine: {Number(confirmStatus?.progress?.processedPages || 0)}
                  /{Number(confirmStatus?.progress?.totalPages || 0)}
                </div>
                {confirmStatus?.progress?.current?.file ? (
                  <div
                    style={{ textAlign: "center", marginTop: 4, fontSize: 12 }}
                  >
                    {confirmStatus.progress.current.file}
                    {confirmStatus?.progress?.current?.page
                      ? ` - pagina ${confirmStatus.progress.current.page}${
                          confirmStatus?.progress?.current?.pageCount
                            ? `/${confirmStatus.progress.current.pageCount}`
                            : ""
                        }`
                      : ""}
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              mt: 2,
              justifyContent: "space-between",
              px: 2,
              width: "100%",
            }}
          >
            <Button
              onClick={handleClose}
              variant="contained"
              className="ButtonMiller"
              startIcon={<Close />}
              disabled={importing}
            >
              Annulla
            </Button>
            <Button
              onClick={handleUpload}
              variant="contained"
              className="ButtonMiller"
              startIcon={<Upload />}
              disabled={
                importing ||
                (analysisJobId && !analysis) ||
                (analysis &&
                  requiresProposalConfirmation &&
                  !confirmProposalsReviewed)
              }
            >
              {importing
                ? "Importando..."
                : analysisJobId
                  ? analysis
                    ? "Procedi"
                    : "Analizzando..."
                  : "Analizza"}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </>
  );
};
